import { Injectable, signal, inject } from '@angular/core';
import { AuthService } from 'src/app/authentication/auth.service';
import { ConstantService } from 'src/app/services/common/constant.service';
import { OrganizationModel } from 'src/app/services/organization';

@Injectable({ providedIn: 'root' })
export class TenantService {
    private constantService = inject(ConstantService);
    private authService = inject(AuthService);


    currentTenant = signal<OrganizationModel | null>(null);
    defaultTenant = signal<OrganizationModel | null>(null);

    setTenant(tenant) {
        this.currentTenant.set(tenant);
        this.constantService.setMspTenant(tenant);
        this.authService.reloadPage();
    }

    resetDefaultTenant(){
        this.setTenant(this.defaultTenant());
    }

    getCurrentTenant(){
        return this.currentTenant() ? this.currentTenant().organizationName: this.constantService.getSubdomain();
    }
}
